import Linkify from "linkify-react";
import React from "react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

const NoDiscountCampCard = ({ campData, storeName }) => {
  return (
    <div
      className="final-no-discount-camp-card"
      style={{
        backgroundColor: campData?.colors?.theme || "#232120",
        color: campData?.colors?.text || "#fff",
      }}
    >
      <div className="card-header">
        <TransformWrapper
          disabled={true}
          initialScale={campData?.banner_position?.scale || 1}
          initialPositionX={campData?.banner_position?.position_x || 0}
          initialPositionY={campData?.banner_position?.position_y || 0}
        >
          <TransformComponent>
            <img
              alt="banner_image"
              title="banner image"
              className="banner_image"
              src={campData?.banner}
            />
          </TransformComponent>
        </TransformWrapper>
      </div>
      <div
        className="card-logo-div"
        style={{
          backgroundColor: campData?.colors?.text || "#fff",
          display: !campData?.isLogoImg ? "block" : "none",
        }}
      >
        {campData?.logo ? (
          <img
            src={campData?.logo}
            width="100px"
            alt="card-logo"
            title="Brand Logo"
            className="card-logo-image"
          />
        ) : (
          <p
            style={{ color: campData?.colors?.theme || "#232120" }}
            className="card-logo-name"
          >
            {storeName || "Reelo"}
          </p>
        )}
      </div>
      <div className="card-content">
        <h3
          className="camptitle"
          style={{
            color: campData?.colors?.text || "#fff",
          }}
        >
          {campData?.title}
        </h3>
        <Linkify
          options={{
            target: "_blank",
          }}
        >
          <p
            className="desc"
            style={{
              color: campData?.colors?.text || "#fff",
            }}
          >
            {campData?.subtitle}
          </p>
        </Linkify>
        {campData?.hide_contact_number ? (
          <></>
        ) : (
          <p className="foot">
            Call{" "}
            <a href={`tel:${campData?.contact_number}`}>
              <u>{campData?.contact_number}</u>
            </a>{" "}
            for more details{" "}
          </p>
        )}
      </div>
    </div>
  );
};

export default NoDiscountCampCard;
